import React from 'react';
import { SvgIcon } from '@material-ui/core';
const Wallet = (props) => (React.createElement(SvgIcon, Object.assign({ style: { fill: 'none', stroke: '#5f6165' } }, props, { viewBox: "0 0 20 21" }),
    React.createElement("path", { d: "M17.4997 3.93884H2.49967C1.5792 3.93884 0.833008 4.68503 0.833008 5.60551V15.6055C0.833008 16.526 1.5792 17.2722 2.49967 17.2722H17.4997C18.4201 17.2722 19.1663 16.526 19.1663 15.6055V5.60551C19.1663 4.68503 18.4201 3.93884 17.4997 3.93884Z" }),
    React.createElement("path", { d: "M0.833008 8.93884H19.1663" })));
export default Wallet;
